import React, { useState, useRef, useEffect } from "react";
import { Container, InputGroup, Form, Button, Row, Col, Tab, Nav, ButtonGroup, Modal, Tooltip, Dropdown } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import ReactSlider from "react-slider";
import { useProfile } from "../contexts/ProfileContext"; // Import the useProfile hook
import axios from "axios";

import ChartComponent from "./FollowerChart";
import RegisterSocial from "./RegisterSocial";
import Upgrade from "./Upgrade";
import Booster from "./Booster";
import Tools from "./Tools";
import { useLocation } from "react-router-dom";
import Alert from "./Alert";
import { useNavigate } from "react-router-dom";

const Magnet = () => {
	const navigate = useNavigate();
  const profile = useProfile(); // Retrieve profile from context
  const [selectedInterests, setSelectedInterests] = useState([]); // Initialize as an empty array
  const [selectedCountries, setSelectedCountries] = useState([]); // Initialize with default country
  const [ageRange, setAgeRange] = useState([18, 65]); // Default min and max age
  const [gender, setGender] = useState("both");
  const [username, setUsername] = useState(profile?.socials?.[profile?.selectedProfile]?.username || ""); 
  const [followers, setFollowers] = useState(profile?.socials?.[profile?.selectedProfile]?.followers || 0);
  const [lastDayChange, setLastDayChange] = useState(profile?.socials?.[profile?.selectedProfile]?.lastDayChange || 0);
  const [lastWeekChange, setLastWeekChange] = useState(profile?.socials?.[profile?.selectedProfile]?.lastWeekChange || 0);
  const [lastMonthChange, setLastMonthChange] = useState(profile?.socials?.[profile?.selectedProfile]?.lastMonthChange || 0);
  const [platform, setPlatform] = useState(profile?.socials?.[profile?.selectedProfile]?.platform || "");
  const [selectedProfile, setSelectedProfile] = useState(profile.selectedProfile || "");
  const [photo, setPhoto] = useState(profile?.socials?.[profile?.selectedProfile]?.photo || "/images/default.png");
  const [currentKey, setCurrentKey] = useState("overview");
  const defaultPhoto = "/images/default.png";
  
  // State to manage the growth rate (10 or 100 followers/day)
  const [growthRate, setGrowthRate] = useState("0");
  const [showProModal, setProModal] = useState(false);
  const handleCloseModal = () => setProModal(false);
  const handleShowModal = () => setProModal(true);

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");

  const [days, setDays] = useState(30);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modeParam = queryParams.get("mode");

  // We'll ensure it's one of the 3 valid tabs; otherwise default to "likes"
  const validModes = ["overview", "boost", "tools"];
  var defaultKey = validModes.includes(modeParam) ? modeParam : "overview";

  useEffect(() => {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set("mode", defaultKey);
    window.history.pushState({}, "", newUrl);
  }, [defaultKey]);
  
  const changeTab = (tab) => {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set("mode", tab);
    window.history.pushState({}, "", newUrl);
	setCurrentKey(tab);
  };

  
  // State for turning the Follower Magnet on/off
  const [followerMagnetOn, setFollowerMagnetOn] = useState(true);

  const [isShaking, setIsShaking] = useState("none");


  useEffect(() => {
    // Set growth rate based on profile's plan
    if (profile?.socials?.[profile?.selectedProfile]?.planName === 'pro' && profile?.socials?.[profile?.selectedProfile]?.status != 'skipped') {
      setGrowthRate("100");
    } else if (profile?.socials?.[profile?.selectedProfile]?.planName === 'basic' && profile?.socials?.[profile?.selectedProfile]?.status != 'skipped') {
      setGrowthRate("50");
    }
  }, [profile?.socials?.[profile?.selectedProfile]?.planName, profile?.socials?.[profile?.selectedProfile]?.status]);
  const handleProClick = async () => {

	if (profile?.socials?.[profile?.selectedProfile]?.status == 'skipped') {
		navigate('/dashboard/settings?tab=invoices');
	}
    if (profile?.socials?.[profile?.selectedProfile]?.planName === 'pro') {
      setGrowthRate("100");
    } else {
      // Trigger shake animation
      setIsShaking("pro");
      
      // Reset the shaking state after the animation duration and then open the modal
      setTimeout(() => {
        setIsShaking("none");
        handleShowModal();
      }, 500); // 500ms matches the CSS animation duration
    }
  };

  const handleBasicClick = async () => {
    if (profile?.socials?.[profile?.selectedProfile]?.planName != 'basic' && profile?.socials?.[profile?.selectedProfile]?.planName != 'pro') {
      setIsShaking("basic");
	  setTimeout(() => {
        setIsShaking("none");
        handleShowModal();
      }, 500); // 500ms matches the CSS animation duration
    }
  };

  const selectProfile = (uuid) => {
    setSelectedProfile(uuid);
	axios.post("https://api.viralgpt.com/auth/select", {
		profileid: uuid
	}, {
		headers: {
			Authorization: `Bearer ${localStorage.getItem("accessToken")}`
		}
	})
	.then(response => {
		window.location.reload();
	})
	.catch(error => {
		console.error("Error selecting profile:", error);
	});
  };
  const [showRegisterSocial, setShowRegisterSocial] = useState(false);
  const addAccount = () => {
    setShowRegisterSocial(true);
  };
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshProfile = () => {
    setIsRefreshing(true);
    axios.post(`https://api.viralgpt.com/auth/refresh`, {
      profileid: profile.selectedProfile
      }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`
      }
    })
	.then(response => {
		console.log(response.data);
		setIsRefreshing(false);
    setFunctionSuccess("Profile refreshed successfully.");
    // small delay to show the message
    setTimeout(() => {
      window.location.reload();
    }, 1500);
	})
	.catch(error => {
		console.error("Error checking private account:", error);
    setFunctionError(error.response?.data?.error || error.response?.data?.message || "Failed to refresh profile.");
		setIsRefreshing(false);
	});
  };
  


  const profileSwitcher = () => {
    return (
      <Dropdown >
		<button 
			onClick={refreshProfile}
			className="absolute top-0 right-0 p-1 hover:bg-gray-200 rounded-full"
		>
			<i className={`fas fa-sync-alt ${isRefreshing ? 'fa-spin' : ''}`}></i>
		</button>
        <Dropdown.Toggle variant="link" className="p-0 text-decoration-none w-100" style={{caretColor: "transparent"}}>
          <div className="flex items-center space-x-4">
			
		  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="w-6 h-6 text-gray-500"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path></svg>
            <div className="flex-shrink-0">
				
              <div className="relative">
                <div className="relative flex flex-col items-center space-y-1">
                  <div className="background-animate rounded-full bg-gradient-to-r p-[0.17rem] from-fuchsia-500/80 via-red-600/50 to-orange-400/50">
                    <div className="block p-1 transition transform bg-white rounded-full">
                      <img 
                        className="h-[60px] w-[60px] rounded-full"
                        src={photo}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="my-auto">
              <div className="flex items-center">
                <h1 className="inline text-[21px] font-bold text-gray-800 font-dashboard tracking-tight  items-center">
                  {platform === "x" ? (
                    <span className="bg-black px-1 rounded-md text-white">𝕏</span>
                  ) : (
                    <i className={`fa-brands fa-${platform} text-${platform}-dark`}></i>
                  )}
                  <span className="ml-2 ">{username.length > 16 ? `${username.slice(0, 16)}...` : username}</span>
                </h1>
              </div>
              <div className="flex gap-2">
                {profile?.socials?.[profile?.selectedProfile]?.planName === "pro" && (
                  <span className="border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit bg-instagram">
                    <i className="fas fa-crown mr-1"></i>
                    PRO
                  </span>
                )}
                {profile?.socials?.[profile?.selectedProfile]?.planName === "basic" && (
                  <span className="border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit bg-dark">
                   
                    BASIC
                  </span>
                )}
                <span className={`border flex items-center rounded-lg px-2 py-1 text-xs font-semibold tracking-normal text-white w-fit ${
                  growthRate === "0" || profile?.socials?.[profile?.selectedProfile]?.isPrivate
                    ? "border-gray-400 bg-gray-400"
                    : "border-green-400 bg-green-600"
                }`}>
                  <i className={`fas fa-${growthRate === "0" || profile?.socials?.[profile?.selectedProfile]?.isPrivate ? "pause" : "signal animate-pulse"} mr-1`}></i>
                  <div className="flex items-center">
					
                    {username === '' ? (
                      <>No Account Linked</>
                    ) : profile?.socials?.[profile?.selectedProfile]?.isPrivate ? (
                      <>Paused - Private Account</>
                    ) : growthRate === "0" ? "Growth Paused" : "ACTIVE"}
                  </div>
                </span>
              </div>
            </div>
			
          </div>
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100 mt-4">
          {profile?.socials && Object.entries(profile.socials).map(([key, social]) => (
            <Dropdown.Item 
              key={key}
              className={`d-flex align-items-center w-100 ${social.profileid === selectedProfile ? 'bg-light' : ''}`}
              onClick={() => selectProfile(social.profileid)}
            >
              <img 
                src={social.photo || defaultPhoto}
                alt="Profile"
                className="rounded-circle me-2"
                style={{width: "30px", height: "30px"}}
              />
			   <div className="w-6">
				{social.platform === 'x' ? (

					<span className="bg-black rounded-md text-white"><i className={`fa-brands fa-twitter-x text-${social.platform || platform}`}></i></span>
					

				) : (
					<i className={`fa-brands fa-${social.platform || platform} text-${social.platform || platform} me-1`}></i>
				)}
			  </div>
			  
              {social.username.length > 16 ? `${social.username.slice(0, 16)}...` : social.username}
              <div className="ms-auto d-flex align-items-center">
                <span className={`badge ${social.planName === 'pro' ? 'bg-instagram' : social.planName === 'basic' ? 'bg-dark' : 'bg-secondary'}`}>
                  {(social.planName || 'NO PLAN').toUpperCase()}
                </span>
				
                <i className={`fas ${social.profileid === selectedProfile ? 'fa-check text-instagram' : 'fa-check text-transparent'} ms-2`}></i>
              </div>
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => addAccount()} className="w-100">
            <i className="fas fa-plus me-2"></i>
            Add Another Account
			
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const interests = [
    { id: "global", label: "🌍 Everyone" },
    { id: "fitness", label: "🏋️‍♂️ Fitness" },
    { id: "travel", label: "✈️ Travel" },
    { id: "fashion", label: "👗 Fashion" },
    { id: "tech", label: "💻 Technology" },
    { id: "food", label: "🍔 Food" },
    { id: "music", label: "🎵 Music" },
    { id: "art", label: "🎨 Art" },
    { id: "gaming", label: "🎮 Gaming" },
    { id: "photography", label: "📸 Photography" },
    { id: "sports", label: "⚽ Sports" },
    { id: "health", label: "🩺 Health" },
    { id: "beauty", label: "💄 Beauty" },
    { id: "books", label: "📚 Books" },
    { id: "movies", label: "🎥 Movies" },
    { id: "pets", label: "🐶 Pets" },
    { id: "business", label: "💼 Business" },
    { id: "realestate", label: "🏡 Real Estate" },
    { id: "homedecor", label: "🏠 Home Decor" },
    { id: "education", label: "🎓 Education" },
    { id: "development", label: "🌱 Personal Development" },
    { id: "wellness", label: "💊 Health & Wellness" },
    { id: "memes", label: "😂 Memes/Humor" },
    { id: "nature", label: "🌳 Nature" },
    { id: "cars", label: "🚗 Cars" },
    { id: "writing", label: "✍️ Writing" },
    { id: "news", label: "📰 News" },
    { id: "science", label: "🔬 Science" },
    { id: "politics", label: "🗳️ Politics" },
    { id: "history", label: "📜 History" }
  ];

  const countries = [
	{ id: "global", label: "🌍 Global" },
	{ id: "us", label: "🇺🇸 United States" },
	{ id: "ca", label: "🇨🇦 Canada" },
	{ id: "mx", label: "🇲🇽 Mexico" },
	{ id: "gb", label: "🇬🇧 United Kingdom" },
	{ id: "au", label: "🇦🇺 Australia" },
	{ id: "nz", label: "🇳🇿 New Zealand" },
	{ id: "de", label: "🇩🇪 Germany" },
	{ id: "fr", label: "🇫🇷 France" },
	{ id: "es", label: "🇪🇸 Spain" },
	{ id: "it", label: "🇮🇹 Italy" },
	{ id: "nl", label: "🇳🇱 Netherlands" },
	{ id: "be", label: "🇧🇪 Belgium" },
	{ id: "se", label: "🇸🇪 Sweden" },
	{ id: "no", label: "🇳🇴 Norway" },
	{ id: "dk", label: "🇩🇰 Denmark" },
	{ id: "ch", label: "🇨🇭 Switzerland" },
	{ id: "at", label: "🇦🇹 Austria" },
	{ id: "pl", label: "🇵🇱 Poland" },
	{ id: "pt", label: "🇵🇹 Portugal" },
	{ id: "gr", label: "🇬🇷 Greece" },
	{ id: "ro", label: "🇷🇴 Romania" },
	{ id: "bg", label: "🇧🇬 Bulgaria" },
	{ id: "hu", label: "🇭🇺 Hungary" },
	{ id: "cz", label: "🇨🇿 Czechia" },
	{ id: "br", label: "🇧🇷 Brazil" },
	{ id: "ar", label: "🇦🇷 Argentina" },
	{ id: "cl", label: "🇨🇱 Chile" },
	{ id: "co", label: "🇨🇴 Colombia" },
	{ id: "pe", label: "🇵🇪 Peru" },
	{ id: "ve", label: "🇻🇪 Venezuela" },
	{ id: "ec", label: "🇪🇨 Ecuador" },
	{ id: "uy", label: "🇺🇾 Uruguay" },
	{ id: "py", label: "🇵🇾 Paraguay" },
	{ id: "bo", label: "🇧🇴 Bolivia" },
	{ id: "cr", label: "🇨🇷 Costa Rica" },
	{ id: "pa", label: "🇵🇦 Panama" },
	{ id: "do", label: "🇩🇴 Dominican Republic" },
	{ id: "gt", label: "🇬🇹 Guatemala" },
	{ id: "sv", label: "🇸🇻 El Salvador" },
	{ id: "hn", label: "🇭🇳 Honduras" },
	{ id: "ni", label: "🇳🇮 Nicaragua" }
	
	
	
  ]

  const emojis = [
    { symbol: "🔥", startX: -100, startY: -550, delay: 0 },
    { symbol: "🥳", startX: 120, startY: -550, delay: 0.5 },
    { symbol: "🤩", startX: -70, startY: -400, delay: 1 },
    { symbol: "✨", startX: 80, startY: -400, delay: 1.5 },
	{ symbol: "🔥", startX: -500, startY: -550, delay: 0 },
    { symbol: "🥳", startX: 520, startY: -550, delay: 0.5 },
    { symbol: "🤩", startX: -570, startY: -500, delay: 1 },
    { symbol: "✨", startX: 580, startY: -500, delay: 1.5 },
	{ symbol: "🔥", startX: -400, startY: -350, delay: 0 },
    { symbol: "🥳", startX: 320, startY: -400, delay: 0.5 },
    { symbol: "🤩", startX: -370, startY: -400, delay: 1 },
    { symbol: "✨", startX: 380, startY: -400, delay: 1.5 },
  ];

  const plans = [
	{
		name: "Pro Plan",
		url: "pro",
		price: { monthly: 69, annual: 41 },
		features: [
		  { icon: "fa-bolt", feature: "Instant Delivery", description: "Get your followers instantly after payment." },
		  { icon: "fa-user-group", feature: "5,000 Followers", description: "Get 5,000 followers per month." },
		  { icon: "fa-gift", feature: "Daily Bonuses", description: "Earn daily bonuses to gain more balance" },
		  { icon: "fa-coins", feature: "$500 Balance For Instant Boosts", description: "Use boost balance to send Likes, Views, and Comments to your posts." },
  
		  { icon: "fa-pencil", feature: "AI Caption Generator", description: "Generate captions for your posts using AI." },
		  { icon: "fa-lightbulb", feature: "Idea Generator", description: "Get ideas for your next post." },
		  { icon: "fa-user-check", feature: "Profile Enhancer", description: "Analyze your profile to get more followers." },
		  { icon: "fa-eye", feature: "Anonymous Story Viewer", description: "View stories anonymously." },
		  { icon: "fa-download", feature: "HQ Post Downloader", description: "Download high-quality posts." },
		],
		popular: true,
	  },
    {
      name: "Basic Plan",
	  url: "basic",
      price: { monthly: 49, annual: 29 }, // Separate pricing for monthly/annual
      features: [
		{ icon: "fa-bolt", feature: "Instant Delivery", description: "Get your followers instantly after payment." },
		{ icon: "fa-user-group", feature: "5,000 Followers", description: "Get 5,000 followers per month." },
		{ icon: "fa-coins", feature: "500 Boost Balance", description: "Use boost balance to send Likes, Views, and Comments to your posts." },
		{ icon: "fa-gift", feature: "Daily Bonuses", description: "Earn daily bonuses to gain more balance" },	
      ],
      popular: false,
    }
  ];

  // Initialize default interests, age range, and gender only once the profile is available
  useEffect(() => {
    if (profile) {
      const defaultInterests = profile?.socials?.[profile?.selectedProfile]?.interests?.split(",") || ["global"];
      const defaultAgeRange = profile?.socials?.[profile?.selectedProfile]?.ageRange?.split("-") || [18, 65];
      const defaultGender = profile?.socials?.[profile?.selectedProfile]?.genderTarget || "both";
      const defaultCountry = profile?.socials?.[profile?.selectedProfile]?.countries?.split(",") || ["global"];

      setSelectedInterests(defaultInterests);
	  setSelectedCountries(defaultCountry);
      setAgeRange(defaultAgeRange);
      setGender(defaultGender);
      setUsername(profile?.socials?.[profile?.selectedProfile]?.username || ""); // Make sure we have Instagram username
    }
  }, [profile]);

  const handleCountryClick = (id) => {
    if (selectedCountries?.includes(id)) {
      setSelectedCountries(selectedCountries.filter((country) => country !== id));
    } else {
      setSelectedCountries([...selectedCountries, id]);
    }
  };


  const handleInterestClick = (id) => {
    if (selectedInterests?.includes(id)) {
      setSelectedInterests(selectedInterests.filter((interest) => interest !== id));
    } else {
      setSelectedInterests([...selectedInterests, id]);
    }
  };
  
  const handleSliderChange = (values) => {
    setAgeRange(values);
  };

  useEffect(() => {
    const saveSettings = async () => {
      try {
        await axios.post(
          "https://api.viralgpt.com/auth/profile/update",
          {
            interests: selectedInterests.join(","),
            ageRange: ageRange.join("-"), 
            profileid: profile.selectedProfile,
            countries: selectedCountries.join(","),
            genderTarget: gender,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );

        
       

      } catch (e) {
        alert("Failed to save settings: " + e.response.data.error);
      }
    };

    // Only call saveSettings if we have a selected profile
    if (profile?.selectedProfile) {
      saveSettings();
    }

  }, [selectedCountries, ageRange, selectedInterests, gender]);
  return (
	<div >

		<Modal show={showRegisterSocial} onHide={() => setShowRegisterSocial(false)} centered size="lg">	
			<Modal.Header closeButton>	
				<Modal.Title>Add Account</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<RegisterSocial 
					show={showRegisterSocial}
					onHide={() => setShowRegisterSocial(false)}
				/>
			</Modal.Body>
		</Modal>
	
<Modal show={showProModal} onHide={handleCloseModal} centered size="xl">
  <Modal.Header closeButton>
    <Modal.Title><strong><span className="bg-instagram text-white p-1 px-3">Compare Plans</span></strong></Modal.Title>
  </Modal.Header>
  <Modal.Body>
	<Upgrade/>
    
    
  </Modal.Body>

</Modal>

    <Container className="rounded  py-4 justify-content-center text-center align-items-center">
	{profile?.invoices?.length > 0 && (
		<div className="alert alert-danger text-center">
			<i className="fas fa-exclamation-triangle me-2"></i>
			You have an outstanding invoice for this month. <a href="/dashboard/settings?tab=invoices" className="text-danger text-decoration-underline">Please pay your invoice</a> to continue using our services.
		</div>
	)}
	<Tab.Container defaultActiveKey={defaultKey}>
        <Nav variant="tabs" className="my-4 nav-tabs-custom mb-3 flex overflow-x-auto whitespace-nowrap justify-between rounded-md  w-full" style={{minHeight: "44px"}}>
          <Nav.Item className="flex-1"><Nav.Link eventKey="overview" onClick={() => changeTab("overview")} className="py-2 px-2 text-center"><i className="fas fa-magnet me-2 text-instagram"></i>Magnet</Nav.Link></Nav.Item>
          {currentKey === "tools" && (
		  <div className="w-px bg-gray-300 h-8 my-auto"></div>
		  )}
		 
          <Nav.Item className="flex-1"><Nav.Link eventKey="boost" onClick={() => changeTab("boost")} className="py-2 px-2 text-center"><i className="fas fa-rocket me-2 text-instagram"></i>Instant Boost</Nav.Link></Nav.Item>
		
		  {currentKey === "overview" && (
		  <div className="w-px bg-gray-300 h-8 my-auto"></div>
		  )}
		  <Nav.Item className="flex-1"><Nav.Link eventKey="tools" onClick={() => changeTab("tools")} className="py-2 px-2 text-center"><i className="fas fa-microchip me-2 text-instagram"></i>AI Tools</Nav.Link></Nav.Item>
        </Nav>

        <Tab.Content>
          <Tab.Pane eventKey="boost" className="text-left">
            <Booster/>
          </Tab.Pane>
          <Tab.Pane eventKey="tools" className="text-left">
            <Tools/>
          </Tab.Pane>
          <Tab.Pane eventKey="overview" className="text-left">

            <Alert 
              variant="success" 
              message={functionSuccess} 
              show={!!functionSuccess} 
              onClose={() => setFunctionSuccess("")} 
            />

	<div className="text-center justify-content-center align-items-center">
      
        <>
          {/* Main container with flex for larger screens */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4">
            
            {/* Instagram Profile Section */}
            <div className="xl:col-span-1">
              <div className="">
                <div className="p-3 items-center rounded-lg border bg-white">
                  {profileSwitcher()}
                </div>
              </div>
            </div>

			<div className="xl:col-span-1 md:col-span-1 xl:col-start-3 md:col-start-2">
              <div className="bg-white p-2 rounded-lg border h-[109px] flex items-center justify-center w-full">
                <div className="grid grid-cols-3 gap-2 w-full h-full">
                  {[
                    { label: "24H", value: lastDayChange, tooltip: "Followers gained in the last 24 hours" },
                    { label: "1W", value: lastWeekChange, tooltip: "Followers gained in the last 7 days" },
                    { label: "1M", value: lastMonthChange, tooltip: "Followers gained in the last 30 days" }
                  ].map((period, index) => (
                    <OverlayTrigger
                      key={index}
                      placement="top"
                      overlay={
                        <Tooltip>{period.tooltip}</Tooltip>
                      }
                    >
                      <div className="bg-gray-50 p-2 rounded text-base flex flex-col justify-center items-center w-full cursor-help">
                        <div className="font-bold text-green-500 mb-1 text-lg">+{profile ? (period.value.toLocaleString()) : "..."}</div>
                        <div className="text-sm font-bold text-gray-600">{period.label}</div>
                      </div>
                    </OverlayTrigger>
                  ))}
                </div>
              </div>
            </div>

            {/* Speed Settings Section */}
            <div className="xl:col-span-1 md:col-span-2 xl:col-start-2 xl:row-start-1 md:col-start-1">
              <div className="bg-white p-2 rounded-lg border flex items-center justify-center w-full">
                <div className="flex flex-col w-full h-full justify-center">
                  <div className="flex bg-gray-100 rounded-lg justify-center w-full h-full">
                    {/* PRO Button */}
                    <div
                      onClick={handleProClick}
                      className={`flex-1 py-3 rounded-lg flex flex-col items-center justify-center relative transition-all duration-200 ${
                        growthRate === "100" ? "bg-gradient-to-br from-white to-gray-50 shadow-lg border-2 border-instagram" : "text-gray-500 cursor-pointer hover:bg-gray-50"
                      } ${
                        isShaking == "pro" ? "shake" : ""
                      }`}
                    >
                      <div className="font-extrabold bg-gradient-to-r bg-instagram rounded text-white text-sm px-3 py-0.5 rounded-full shadow-sm mb-2">
                        PRO
                      </div>
                      <div className="font-semibold text-xs text-center leading-snug">
                        100 {platform === "youtube" ? "Subscribers" : "Followers"} Daily
                      </div>
                      {growthRate === "100" && (
                        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-green-600 rounded text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1">
                          <strong>ACTIVE</strong>
                        </div>
                      )}
                    </div>

                    <div className="w-px bg-gray-300 h-14 my-auto mx-1.5"></div>

                    {/* BASIC Button */}
                    <div
                      onClick={handleBasicClick}
                      className={`flex-1  py-3 rounded-lg flex flex-col items-center justify-center relative transition-all duration-200 ${
                        growthRate === "50" ? "bg-white shadow-md border-2 border-instagram" : "text-gray-500 hover:bg-gray-50 cursor-pointer"
                      } ${
                        isShaking == "basic" ? "shake" : ""
                      }`}
                    >
                      {growthRate === "50" && (
                        <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 bg-green-600 rounded text-white text-xs px-2 py-0.5 rounded-full flex items-center gap-1">
                          <strong>ACTIVE</strong>
                        </div>
                      )}
                      <div className="font-bold bg-gray-600 text-white text-sm px-3 py-0.5 rounded-full shadow-sm mb-2">
                        BASIC
                      </div>
                      <div className="font-medium text-xs text-center leading-snug">
                        50 {platform === "youtube" ? "Subscribers" : "Followers"} Daily
                      </div>
                    </div>
                  </div>
                  
                  {growthRate === "0" && (
                    <button 
                      className="bg-gradient-to-r from-instagram to-instagram-2 pulse-glow text-white px-6 py-2 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-200 w-full mt-2" 
                      onClick={handleProClick}
                    >
                      <i className="fas fa-play mr-2"></i>
                      Start Growth
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Follower Counts Section */}
            

          </div>
        </>
  
    </div>

	
	
		<div className="bg-white border rounded p-4 mt-4">
              <h5>Projected Growth</h5>
              <p className="text-muted">Your account {growthRate != "0" ? 'will' : 'could'} reach <strong>{(followers + ((growthRate === "0" ? "100" : growthRate) * days)).toLocaleString()}</strong> {platform === "youtube" ? "subscribers" : "followers"} in {days > 30 ? `${Math.round(days/30)} months` : `${days} days`}.</p>

       
         
            <div className="rounded  w-100">
              <ChartComponent followers={followers} growthRate={growthRate === "0" ? "100" : growthRate} days={days}/>
              
              <div className="flex justify-center mt-6">
                <div className="inline-flex bg-gray-100 p-1 rounded-lg shadow-sm">
                  <button onClick={() => setDays(30)} className={`px-4 py-2.5 rounded-md font-medium text-sm transition-all duration-200 ${days === 30 ? 'border-instagram text-dark shadow-sm' : 'hover:bg-gray-200'}`}>1M</button>
                  <button onClick={() => setDays(180)} className={`px-4 py-2.5 rounded-md font-medium text-sm mx-1 transition-all duration-200 ${days === 180 ? 'border-instagram text-dark shadow-sm' : 'hover:bg-gray-200'}`}>6M</button>
                  <button onClick={() => setDays(360)} className={`px-4 py-2.5 rounded-md font-medium text-sm transition-all duration-200 ${days === 360 ? 'border-instagram text-dark shadow-sm' : 'hover:bg-gray-200'}`}>1Y</button>
                </div>
              </div>
            </div>
          
</div>
          
            <div className="bg-white mt-4 border rounded p-4 text-start">
              <h5>Target Interests</h5>
              <p className="text-muted">ViralGPT uses AI to recognize the user's interests from their bio & posts.</p>

             
              <Form.Group className="mb-4 bg-gray-100 p-2 rounded border p-3">
                
                <div className="d-flex flex-wrap gap-1">
                  {interests.map((interest) => (
                    <div
                      key={interest.id}
                      onClick={() => {
                        if (interest.id === "global") {
                          // If clicking global, clear other selections
                          if (selectedInterests.includes("global")) {
                            handleInterestClick("global");
                          } else {
                            setSelectedInterests(["global"]);
                          }
                        } else {
                          // If clicking non-global interest
                          handleInterestClick(interest.id);
                          // If no interests selected after click, select global
                          const updatedInterests = selectedInterests.includes(interest.id) 
                            ? selectedInterests.filter(i => i !== interest.id)
                            : [...selectedInterests, interest.id];
                          if (updatedInterests.length === 0) {
                            setSelectedInterests(["global"]);
                          } else {
                            // Remove global if selecting other interests
                            setSelectedInterests(updatedInterests.filter(i => i !== "global"));
                          }
                        }
                      }}
                      className={`rounded px-2 m-1 py-2 ${
                        selectedInterests?.includes(interest.id)
                          ? "border-instagram text-dark cursor-pointer"
                          : "bg-white  text-secondary cursor-pointer rounded"
                      }`}
                    >
                      {interest.label}
                    </div>
                  ))}
                </div>
              </Form.Group>
			</div>

			<div className="bg-white mt-4 border rounded p-4 text-start">
				<h5>Target Countries</h5>
				<p className="text-muted">ViralGPT will only target {platform === "youtube" ? "subscribers" : "followers"} from the selected countries.</p>
				<Form.Group className="mb-4 bg-gray-100 p-2 rounded border p-3">
				<div className="d-flex flex-wrap gap-1">
					{countries.map((country) => (
						<div
							key={country.id}
							onClick={() => {
								if (country.id === "global") {
									// If clicking global, clear other selections
									if (selectedCountries.includes("global")) {
										handleCountryClick("global");
									} else {
										setSelectedCountries(["global"]);
									}
								} else {
									// If clicking non-global country
									handleCountryClick(country.id);
									// If no countries selected after click, select global
									const updatedCountries = selectedCountries.includes(country.id)
										? selectedCountries.filter(c => c !== country.id)
										: [...selectedCountries, country.id];
									if (updatedCountries.length === 0) {
										setSelectedCountries(["global"]);
									} else {
										// Remove global if selecting other countries
										setSelectedCountries(updatedCountries.filter(c => c !== "global"));
									}
								}
							}}
							className={`rounded px-2 m-1 py-2 ${
								selectedCountries?.includes(country.id)
									? "border-instagram text-dark cursor-pointer"
									: "bg-white text-secondary cursor-pointer rounded"
							}`}
						>
							{country.label}
						</div>
					))}
				</div>
				</Form.Group>
			

			</div>
			<br></br>
			<div className="bg-white mt-4 border rounded p-4 text-start">
				<h5>Target Demographics</h5>
				<p className="text-muted">ViralGPT will only target {platform === "youtube" ? "subscribers" : "followers"} within the selected age range and gender.</p>

				<Form.Group className="mb-4">	

              <p>{ageRange[0]} - {ageRange[1]} years</p>
              <ReactSlider
                className="custom-slider"
                thumbClassName="custom-thumb"
                trackClassName="custom-track"
                min={13} // Set min age range to 13
                max={100} // Set max age range to 100
                value={ageRange}
                onChange={handleSliderChange}
                pearling
                minDistance={1} // Minimum distance between handles
                renderTrack={(props, state) => (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      background:
                        state.index === 0
                          ? "lightgray" // Before the first thumb
                          : state.index === 1
                          ? "linear-gradient(45deg, #4b25ea, #bd18e6, #fb590e)" // Between the thumbs
                          : "lightgray", // After the second thumb
                    }}
                  />
                )}
              />

			</Form.Group>
			<br></br>
			
			<Form.Group className="mb-4 bg-gray-100 p-2 rounded border p-3">	
             
              <div className="d-flex flex-wrap justify-content-center gap-2">
                <div
                  onClick={() => setGender("male")}
                  className={`rounded px-2 m-1 py-2 d-flex align-items-center flex-grow-1 ${
                    gender === "male" 
                      ? "border-instagram cursor-pointer"
                      : "bg-white text cursor-pointer rounded"
                  }`}
                >
                  <span style={{fontSize: "3em", marginRight: "1rem"}}>👨</span>
                  <div>
                    <div className="fw-bold">Male</div>
                    <small className={gender === "male" ? "text-muted" : "text-muted"}>Target more male {platform === "youtube" ? "subscribers" : "followers"}</small>
                  </div>
                </div>
                <div
                  onClick={() => setGender("female")}
                  className={`rounded px-2 m-1 py-2 d-flex align-items-center flex-grow-1 ${
                    gender === "female"
                      ? "border-instagram cursor-pointer" 
                      : "bg-white text cursor-pointer rounded"
                  }`}
                >
                  <span style={{fontSize: "3em", marginRight: "1rem"}}>👩</span>
                  <div>
                    <div className="fw-bold">Female</div>
                    <small className={gender === "female" ? "text-muted" : "text-muted"}>Target more female {platform === "youtube" ? "subscribers" : "followers"}</small>
                  </div>
                </div>
                <div
                  onClick={() => setGender("both")}
                  className={`rounded px-2 m-1 py-2 d-flex align-items-center flex-grow-1 ${
                    gender === "both"
                      ? "border-instagram  cursor-pointer"
                      : "bg-white text cursor-pointer rounded"
                  }`}
                >
                  <span style={{fontSize: "3em", marginRight: "1rem"}}>👫</span>
                  <div>
                    <div className="fw-bold">Both</div>
                    <small className={gender === "both" ? "text-muted" : "text-muted"}>Target all genders</small>
                  </div>
                </div>
              </div>
			  </Form.Group>

			
            </div>
       
			</Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  </div>
  );
};

export default Magnet;
